import { ReactNode } from 'react';
import { MarketButton } from '@market/react';

// When href is set MarketButton renders as an anchor, so a CTA can be either a
// JS action or a link (Contact sales, Get started) without a separate component.
interface SecondaryProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}

const Secondary = ({
  children,
  className = '',
  onClick,
  href,
}: SecondaryProps) => {
  return (
    <MarketButton
      rank="secondary"
      className={className}
      onClick={onClick}
      data-testid="cta-subnav-secondary"
      href={href}
    >
      {children}
    </MarketButton>
  );
};

export default Secondary;
